import _concat from "lodash/concat";
import importer from "./importer";
import overview from "./overview";

export default {
  path: "/project-importer",
  component: () => import("@/layouts/FullLayout"),
  children: _concat(importer, overview)
};
